import React from 'react';
import cx from 'classnames';

import imgLogo from 'assets/img/welcome.svg';
import ribbon1Img from 'assets/img/ribbon1.svg';
import ribbon2Img from 'assets/img/ribbon2.svg';
import ribbon3Img from 'assets/img/ribbon3.svg';
import ribbon4Img from 'assets/img/ribbon4.svg';
import { ShowArroundSteps } from '../ShowAroundPage';
import { StepKeys } from '../WelcomePage/ProfileSetupForm';
import { userSelector } from 'redux/selectors/authenticationSelectors';
import { useAppSelector } from 'hooks/useAppSelector';

import styles from './WelcomeSectionWrapper.module.less';

type Props = {
  children: React.ReactNode;
  completedStepsCount: number;
};

const OnboardingSteps = { ...StepKeys, ...ShowArroundSteps };

export default function WelcomeSectionWrapper(props: Props) {
  const user = useAppSelector(userSelector);
  const { completedStepsCount, children } = props;

  const getPageBgClassName = () => {
    switch (completedStepsCount) {
      case OnboardingSteps.EntitySelection:
        return styles.entityTypeStep;

      case OnboardingSteps.Profile:
        return styles.entityInfoStep;

      case OnboardingSteps.Outreach:
        return styles.outreachStep;

      case OnboardingSteps.ShowArround:
        return styles.showAroundStep;

      default:
        return '';
    }
  };

  return (
    <div className={cx(styles.welcomePage, getPageBgClassName())}>
      <div className={styles.contentBox}>
        <div className={styles.welcomeName}>
          <span>{user?.firstName}</span>,
        </div>

        {/* Preload images in order to prevent blinking on background-image change */}
        <div className={styles.preload}>
          <img src={ribbon1Img} alt="Ribbon 1" />
          <img src={ribbon2Img} alt="Ribbon 2" />
          <img src={ribbon3Img} alt="Ribbon 3" />
          <img src={ribbon4Img} alt="Ribbon 4" />
        </div>

        <div className={styles.title}>
          <span>Welcome to</span>
          <img src={imgLogo} alt="logo" />
        </div>

        {children}
      </div>
    </div>
  );
}
